import * as angular from 'angular';

import {
  OnInit,
  Component,
  Input,
} from 'ng-metadata/core';

import searchLocationsHtml from './search-locations.html';


@Component({
  selector: 'gwSearchLocations',
  template: searchLocationsHtml,
})
export class SearchLocationsComponent implements OnInit {
  public radius = 5;
  public locationsForm

  @Input() route: string;

  public laroute = (<any>window).laroute;

  ngOnInit() {
  }

  search(zip: number, radius: string) {
    this.locationsForm.$setSubmitted()

    if (this.locationsForm.$valid) {
      window.location.assign(this.laroute.route(this.route, {
        zip,
        radius,
      }));
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/locations/search-locations.component.ts